import { useAppHistory } from "@faire/help-center-utils/AppHistory";
import supportHome, { route as supportHomeRoute } from "@faire/web-api/routes/support";
import { DEFAULT_LOCALE_KEY } from "@faire/web/common/consts/DEFAULT_LOCALE";
import { hardRefresh } from "@faire/web/common/hardRefresh";
import { IntlProvider } from "@faire/web/common/localization/IntlProvider";
import { LocalizationStore } from "@faire/web/common/localization/LocalizationStore";
import { QueryClientProvider } from "@faire/web/common/reactQuery";
import { FontStyle } from "@faire/web/slate/Font/GlobalFontStyle";
import { DefaultTheme } from "@faire/web/slate/Theme";
import { ThemeProvider } from "@faire/web/slate/Theme/ThemeProvider";
import { FaireErrorBoundary } from "@faire/web/ui/FaireErrorBoundary/FaireErrorBoundary";
import { GlobalStyleResets } from "@faire/web/ui/GlobalStyleResets";
import { ObservableWindowStoreProvider } from "@faire/web/ui/hooks/useObservableWindow";
import { RoutingContext } from "@faire/web/ui/routing/RoutingContext";
import { Switch } from "@faire/web/ui/routing/Switch";
import * as React from "react";
import { Route, Router } from "react-router-dom";
import { AppRoutes } from "./AppRoutes";
import { HelpCenterHelmet } from "./components/HelpCenterHelmet/HelpCenterHelmet";
import { ArticleContextProvider } from "./views/articles/hooks/ArticleContext";
export var App = function App() {
  var _LocalizationStore$ge;
  var _useAppHistory = useAppHistory(["history"]),
    history = _useAppHistory.history;
  return /*#__PURE__*/React.createElement(IntlProvider
  // locale and defaultLocale will always be the same since we're inlining translations
  , {
    // locale and defaultLocale will always be the same since we're inlining translations
    localeKey: (_LocalizationStore$ge = LocalizationStore.get().localeKey) !== null && _LocalizationStore$ge !== void 0 ? _LocalizationStore$ge : DEFAULT_LOCALE_KEY,
    defaultLocale: LocalizationStore.get().locale,
    messages: {}
  }, /*#__PURE__*/React.createElement(RoutingContext.Provider, {
    value: {
      locale: LocalizationStore.get().locale
    }
  }, /*#__PURE__*/React.createElement(FaireErrorBoundary, {
    logFatal: true,
    fullPage: true,
    history: history,
    helpCenterPage: true
  }, /*#__PURE__*/React.createElement(ObservableWindowStoreProvider, null, /*#__PURE__*/React.createElement(FontStyle, null), /*#__PURE__*/React.createElement(GlobalStyleResets, null), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: DefaultTheme
  }, /*#__PURE__*/React.createElement(ArticleContextProvider, null, /*#__PURE__*/React.createElement(QueryClientProvider, null, /*#__PURE__*/React.createElement(HelpCenterHelmet, null), /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: supportHomeRoute,
    component: AppRoutes
  }), /*#__PURE__*/React.createElement(Route, {
    component: function component() {
      return hardRefresh("help-center", supportHome());
    }
  }))))))))));
};